import React from 'react'
import ReactApexChart from "react-apexcharts";
import HeaderTitle from '../../CopyPeopleList/HeaderTitle'
import { useTranslation } from "react-i18next";
import './TradingProgressChart.css'

function TradingProgressChart() {
    const { i18n } = useTranslation();
    var dir = "ltr";

    if (i18n.language === "ar") {
        dir = "ltr";
    }
    const state = {

        series: [{
            name: 'Stocks',
            data: [44]
        }, {
            name: 'Indices',
            data: [53]
        }, {
            name: 'Currencies',
            data: [9]
        }, {
            name: 'Commodities',
            data: [25]
        }],
        options: {
            chart: {
                type: 'bar',
                height: 100,
                stacked: true,
                stackType: '100%'
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                },
            },
            stroke: {
                width: 0,
                dis: false,
                colors: ['#red']
            },
            title: {
                text: ''
            },
            xaxis: {
                labels: {
                    show: false
                }, lines: {
                    show: false
                }
            },
            yaxis: {
                labels: {
                    show: false
                }, lines: {
                    show: false
                }
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + "K"
                    }
                }
            },
            fill: {
                opacity: 1

            },
            legend: {

                position: 'top',
                horizontalAlign: 'left',
                offsetX: 40
            }
        },


    };
    return (
        <div style={{ width: "100%" }}>
            <HeaderTitle title="Trading" dir={dir} />
            <div className="performance-trades-main-info">
                <div className="performance-total-trades">
                    <span className="performance-chart-icon sprite-stats">
                    </span>
                    <div className="performance-num"> 375
                        <span className="title">Total Trades</span>
                    </div>
                </div>
                <div className="top-colum-stats">
                    <div className="top-trade-stat">
                        <span className="positive">
                            <span className="sprite">
                            </span> 12.97% </span>
                        <span  > Avg. Profit </span>
                    </div>
                    <div className="top-trade-stat">
                        <span className="negative">
                            <span className="sprite"></span>-7.28%</span><span  > Avg. Loss </span>
                    </div>
                </div>
                <div className="top-trading-colum top-pie">
                   
                    <div className="top-trade-profit">
                        <span className="top-trade-profit-procent">73.07%</span>
                        <span className="profit">Profitable</span>
                    </div>
                </div>
            </div>

            <div id="TradingProgressChart">
                <ReactApexChart options={state.options} series={state.series} type="bar" height={100} />
            </div>
        </div>
    )
}

export default TradingProgressChart
